// import * as Sentry from '@sentry/react';
import settings from 'config/settings';
// import initGA from './init-ga';
import initSentry from '../sentry';

export default function startup() {
  // TODO: Add init functions here
  if (settings.isProduction) initSentry();
}
